import { FONT_FAMILY } from '@constants/fonts.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import type { DatePickerProps } from 'antd';
import { DatePicker } from 'antd';
import styled from 'styled-components';

const StyledDatePicker = styled((props: DatePickerProps) => <DatePicker {...props} />)`
    width: 100%;
    height: 46px;

    .ant-picker-input {
        input {
            ${FONT_FAMILY.poppins};
            ${DESKTOP_SIZES[SIZES.BODY_MD].fontSize};
        }
    }
`;

export default StyledDatePicker;
